import React from 'react';
import Sidebar from './SideBar';
import PersonalInfoForm from './PersonalInfoForm';
import Navbar from '../NavBar';
import SectionBreak from '../SectionBreak';
import Footer from '../Footer';

const Index = () => {
  return (
    <>
      <Navbar />
      {/* <SectionBreak /> */}
      <div className="flex flex-col md:flex-row min-h-screen bg-white pt-[80px]">
        <div className="w-full md:w-64 flex-shrink-0">
          <Sidebar />
        </div>
        <div className="flex-grow flex items-start justify-center">
          <PersonalInfoForm />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Index;